/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CheckPointsDataParser = /* #__PURE__ */ parsers.object([
    ['minPoints', codecNumber, 'min_points'],
]);
export class CheckPointsData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CheckPointsDataParser.decode(input).map(res => new CheckPointsData(res));
    }
    static unsafeDecode(input) {
        return CheckPointsData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CheckPointsDataParser.encode(data);
    }
    static schema() {
        return CheckPointsDataParser.schema();
    }
}
